import React from 'react';
import moment from 'moment';
import htmlParser from 'react-html-parser';
import {
  flow,
  get,
  getOr,
  isNumber,
  join,
  map,
  split,
  startCase
} from 'lodash/fp';
import { parseInt } from '../../../helpers/utils';
import { StringOrNumberType } from '../../../interfaces';
import { ColumnSettingsType } from '../../../interfaces/guest';
import Relationship from '../../guest/Relationship';

const EmptyValue = '""';

const CustomFieldValue = ({ value, colSettings }) => {
  const { name, fieldType, options = [] } = colSettings;
  switch (fieldType) {
    case 'file':
      return 'with a new file';
    case 'guest_relation':
      if (!value || value === '0') return EmptyValue;
      return <Relationship guestId={parseInt(value)} />;
    case 'radio':
    case 'select':
      return value ? htmlParser(getOr(value, value, options)) : EmptyValue;
    case 'option_yesno':
      return getOr('No', value, options);
    case 'checkbox':
      if (!value) return EmptyValue;
      return flow(
        split(','),
        map(val => htmlParser(get(val, options))),
        join(', ')
      )(value);
    case 'date':
      // eslint-disable-next-line no-case-declarations
      const date = isNumber(value) ? moment(value * 1000) : value;
      return moment(date).format('ll');
    case 'datetime':
      // eslint-disable-next-line no-case-declarations
      const datetime = isNumber(value) ? moment(value * 1000) : value;
      return moment(datetime).format('lll');
    default:
      if (!value) return EmptyValue;
      if (name === 'name') return startCase(value);
      return value;
  }
};

CustomFieldValue.propTypes = {
  value: StringOrNumberType.isRequired,
  colSettings: ColumnSettingsType.isRequired
};

export default CustomFieldValue;
